import router from "./index";

export default store => {
  router.beforeEach((to, from, next) => {
    store.dispatch("setChunkLoading", true);

    return next();
  });
  router.afterEach(to => {
    store.dispatch("setChunkLoading", false);
    const matchedPrefixes = ["/deposit", "/withdraw", "/tx", "/proposals"];
    const matchedRouteNames = ["StakeProjectDetails", "VaultDetails"];
    if (
      matchedPrefixes.every(prefix => !to.path.includes(prefix)) &&
      matchedRouteNames.every(name => to.name !== name)
    ) {
      store.dispatch("projectConfig/setCurrentProject", null);
    }
  });
};
